import * as React from "react";
import { Icon, Link } from "@fluentui/react";
import { NavigationLink } from "../Navigation/Navigation";

export interface PageNavigation {
  /**
   * A relative path to access when cicking on the link
   */
  to: string;
  /**
   * The key of the page that will display when the link is clicked
   */
  pageKey: string;
  /**
   * To store additional information with navigation
   */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  customData?: { [key:string]: any },
}

export interface CustomNavigation {
  /**
   * Callback to provide an action to execute when the link is clicked
   */
  onClick: () => void;
}

export type NavigationType = PageNavigation | CustomNavigation;

export interface ListingDisplayNameLinkProps {
  /**
   * The link text to be displayed
   */
  displayName: string;
  /**
   * An optional icon to be displayed before the link text
   */
  iconName?: string;
  /**
   * Specify the navigation behaviour of the linl
   */
  navigation: NavigationType;
}

/**
 * A Name link that supports an optional icon to be displayed inside listings
 */

export const ListingDisplayNameLink = ({
  displayName,
  navigation,
  iconName,
}: ListingDisplayNameLinkProps): JSX.Element => {
  const isPageNavigation = (nav: NavigationType): boolean => "to" in nav;
  return (
    <span style={{ display: "flex" }}>
      {iconName && (
      <Icon
        iconName={iconName}
        styles={{
          root: {
            width: "24px",
            height: "18px",
            top: "-2px",
            position: "absolute",
            display: "flex",
          },
        }}
      />
      )}
      <div style={{ marginLeft: iconName ? "24px" : undefined }}>
        {isPageNavigation(navigation) ? (
          <NavigationLink
            to={(navigation as PageNavigation).to}
            pageKey={(navigation as PageNavigation).pageKey}
            customData={(navigation as PageNavigation).customData}
          >
            {displayName}
          </NavigationLink>
        ) : (
          <Link onClick={(navigation as CustomNavigation).onClick}>
            {displayName}
          </Link>
        )}
      </div>
    </span>
  );
};
